"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueProcessMode = void 0;
var lodash_1 = __importDefault(require("lodash"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var QueueProcessMode;
(function (QueueProcessMode) {
    QueueProcessMode["OneByOne"] = "OneByOne";
    QueueProcessMode["FastForward"] = "FastForward";
})(QueueProcessMode || (exports.QueueProcessMode = QueueProcessMode = {}));
var isSuccessfulResult = function (result) {
    return result.handled;
};
var QueueProcessor = (function () {
    function QueueProcessor(_a) {
        var processor = _a.processor, onDone = _a.onDone, _b = _a.processMode, processMode = _b === void 0 ? QueueProcessMode.OneByOne : _b, _c = _a.retryDelay, retryDelay = _c === void 0 ? 500 : _c;
        this.enabled = true;
        this.taskList = [];
        this.taskInProgress = false;
        this.processor = processor;
        this.onDone = onDone;
        this.processMode = processMode;
        this.retryDelay = retryDelay;
    }
    Object.defineProperty(QueueProcessor.prototype, "pendingTasks", {
        get: function () {
            return this.taskList;
        },
        enumerable: false,
        configurable: true
    });
    QueueProcessor.prototype.enqueue = function () {
        var _a;
        var tasks = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tasks[_i] = arguments[_i];
        }
        (_a = this.taskList).push.apply(_a, __spreadArray([], __read(tasks), false));
        this.next();
    };
    Object.defineProperty(QueueProcessor.prototype, "nextBatch", {
        get: function () {
            switch (this.processMode) {
                case QueueProcessMode.OneByOne:
                    return { task: this.taskList[0], size: 1 };
                case QueueProcessMode.FastForward:
                    return { task: lodash_1.default.last(this.taskList), size: this.taskList.length };
                default:
                    throw new Error("Unrecognised QueueProcessMode: ".concat(this.processMode));
            }
        },
        enumerable: false,
        configurable: true
    });
    QueueProcessor.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, task, batchSize, result;
            var _b;
            var _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.enabled || this.taskInProgress || lodash_1.default.isEmpty(this.taskList)) {
                            return [2];
                        }
                        this.taskInProgress = true;
                        _a = this.nextBatch, task = _a.task, batchSize = _a.size;
                        return [4, this.processor(task)];
                    case 1:
                        result = _f.sent();
                        if (!isSuccessfulResult(result)) return [3, 2];
                        (_b = this.taskList).splice.apply(_b, __spreadArray([0, batchSize], __read(((_c = result.additionalTasks) !== null && _c !== void 0 ? _c : [])), false));
                        if (result.pause) {
                            this.enabled = false;
                        }
                        return [3, 4];
                    case 2: return [4, (0, utils_1.delay)((_d = result.retryDelay) !== null && _d !== void 0 ? _d : this.retryDelay)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        this.taskInProgress = false;
                        if (this.enabled && !lodash_1.default.isEmpty(this.taskList)) {
                            this.next();
                        }
                        else {
                            (_e = this.onDone) === null || _e === void 0 ? void 0 : _e.call(this);
                        }
                        return [2];
                }
            });
        });
    };
    return QueueProcessor;
}());
exports.default = QueueProcessor;
